/* eslint-disable linebreak-style */
import { makeVar } from '@apollo/client'

const getChannelId = () => {
  let channel = null

  if (typeof sessionStorage !== 'undefined' && sessionStorage) {
    if ('channelId' in sessionStorage) {
      channel = sessionStorage.channelId
    } else if ('Channel' in sessionStorage) {
      channel = sessionStorage.Channel
    }

    return channel
  }

  return channel
}

export const mobileChannels = ['iOSRebraded', 'android rebranded']
export const ipadChannels = ['ipad rebranded']
export const desktopChannels = ['OLB']
export const tuxChannels = ['TUX']
export const mobileIpadChannels = [...mobileChannels, ...ipadChannels]
const getSessionValue = () => {
  const channel = getChannelId()

  if (mobileChannels.includes(channel)) {
    return 'MBL'
  }
  if (ipadChannels.includes(channel)) {
    return 'IPAD'
  }

  return channel
}

/**
 *appCache
 */

export const appCache = makeVar({
  /*
   * Enter your module variables here
   */
  Channel: getSessionValue() ?? 'OLB',
  Title: ''
})

export const aemContentCache = makeVar({})
export const systemErrorCache = makeVar({})
export const inlineErrorCache = makeVar({})
export const errorContentCache = makeVar({})
